import React, { useState, useCallback } from 'react';
import { debounce } from 'lodash';

const ToggleElement = ({ id, onChange, delay = 300, initial = false, label, enableStateLabel, disableStateLabel }) => {
  const [isOn, setIsOn] = useState(initial);

  const debouncedChange = useCallback(
    debounce((value) => onChange(id, value), delay),
    [onChange, id, delay],
  );

  const handleChange = (e) => {
    const newValue = e.target.checked;
    setIsOn(newValue);
    debouncedChange(newValue);
  };

  return (
    <div>
      <label className="flex cursor-pointer items-center gap-2">
        <div className="relative inline-block h-4 w-6 ">
          <input type="checkbox" checked={isOn} onChange={handleChange} className="peer sr-only" />
          <div className="size-full rounded-full border-2 border-neutral-950 bg-white transition-colors peer-checked:bg-neutral-950" />
          <div className="absolute left-1 top-1 size-2 rounded-full border-2 border-neutral-950 bg-white transition-transform peer-checked:translate-x-2 peer-checked:border-white" />
        </div>
        <span>
          {label} {isOn ? enableStateLabel : disableStateLabel}
        </span>
      </label>
    </div>
  );
};

export default ToggleElement;
